/**
 * The الحظر cell, for every page that lists accounts.
 *
 * ONE COMPONENT, because the people pages and the restaurants page show the
 * same fact about the same table. `users.isBlocked` and `users.archivedAt`
 * carry it for a restaurant exactly as they do for a driver, so two copies of
 * this button could only ever disagree — and a control that says "غير محظور"
 * on one screen and nothing at all on another is worse than no control.
 *
 * THREE STATES, NOT TWO. `مؤرشف` is separate from `محظور` on purpose. An
 * account an admin banned and an account that removed itself both stop working,
 * and an operator deciding whether to let someone back in has to tell those
 * apart. Without the third state a driver who deleted their own account looked
 * exactly like one we banned.
 *
 * ONE CONTROL EITHER WAY. The same click restores an archived account and
 * un-bans a blocked one, because on the server both are the same un-block,
 * which also clears the stamp.
 *
 * The colours stay solid in dark mode. `AGENTS.md` asks for a low-alpha wash
 * for a status *label*, and keeps solid fills for a decisive control. This is a
 * button that bans an account, so it is the second kind.
 */
import { formatDate } from "utils/dateFormat";

const BlockStatusButton = ({ account, onToggle }) => {
    const archivedAt = account?.archivedAt;
    const isBlocked = account?.isBlocked;

    const label = archivedAt ? "مؤرشف" : isBlocked ? "محظور" : "غير محظور";
    const background = archivedAt ? "#6c757d" : isBlocked ? "#dc3545" : "#198754";

    return (
        <button
            className="btn btn-sm block-status-btn"
            style={{ backgroundColor: background, color: "#fff", minWidth: "90px" }}
            // The date matters when deciding whether to restore, but it does
            // not deserve a column of its own on a table that already scrolls
            // sideways.
            title={
                archivedAt
                    ? `تمت إزالة الحساب في ${formatDate(archivedAt)} — اضغط للإرجاع`
                    : undefined
            }
            onClick={() => onToggle(account)}
        >
            {label}
        </button>
    );
};

export default BlockStatusButton;
